import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClasseListaComponent } from './classe-lista/classe-lista.component';
import {ClasseEdicaoComponent} from './classe-edicao/classe-edicao.component';
import { ClasseVisualizacaoComponent } from './classe-visualizacao/classe-visualizacao.component';

const routes: Routes = [
  { path: 'classe/listar', component: ClasseListaComponent, data: { titulo: 'Lista as Classes' }  },
  { path: 'classe/edicao/:id', component: ClasseEdicaoComponent, data: { titulo: 'Edição de Classe' } },
  { path: 'classe/visualizar/:id', component: ClasseVisualizacaoComponent, data: { titulo: 'Visualizar Tipo Movimento' }  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClasseRoutingModule { }
